export default {"src":"/_next/static/media/bnb.44e0e1dd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};